import { useState, type FormEvent } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { useAuth } from '../auth/AuthAllapot.tsx';
import { biztonsagosVissza } from '../auth/belepes.ts';
import { supabase } from '../lib/supabase.ts';
import { Gomb, Mezo } from '../ui/elemek.tsx';
import BelepesKeret from './BelepesKeret.tsx';

// Az iroda-regisztráció kapcsolója: alapból ki van kapcsolva, a link csak bekapcsolva jelenik meg.
const REGISZTRACIO_BE = import.meta.env.VITE_REGISZTRACIO === 'be';

const KORLAT_SZOVEG = 'Túl sok kérés, próbáld újra pár perc múlva.';

function korlatHiba(hiba: { status?: number; code?: string; message: string }): boolean {
  return hiba.status === 429 || hiba.code === 'over_email_send_rate_limit' || /rate limit/i.test(hiba.message);
}

export default function Belepes() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { frissites } = useAuth();
  const [email, setEmail] = useState('');
  const [kod, setKod] = useState('');
  const [elkuldve, setElkuldve] = useState(false);
  const [kuldes, setKuldes] = useState(false);
  const [ellenorzes, setEllenorzes] = useState(false);
  const [hiba, setHiba] = useState<string | null>(null);

  async function linkKeres(e: FormEvent) {
    e.preventDefault();
    setKuldes(true);
    setHiba(null);
    const { error } = await supabase.auth.signInWithOtp({ email: email.trim(), options: { shouldCreateUser: false } });
    setKuldes(false);
    if (error && korlatHiba(error)) {
      setHiba(KORLAT_SZOVEG);
      return;
    }
    // Szándékosan elnyelt hiba: ismeretlen címre is ugyanazt a visszajelzést adjuk, hogy ne derüljön ki, van-e fiók.
    setElkuldve(true);
  }

  async function kodBeker(e: FormEvent) {
    e.preventDefault();
    setEllenorzes(true);
    setHiba(null);
    const { error } = await supabase.auth.verifyOtp({ email: email.trim(), token: kod.trim(), type: 'email' });
    if (error) {
      setEllenorzes(false);
      setHiba(korlatHiba(error) ? KORLAT_SZOVEG : 'A kód hibás vagy lejárt. Kérj új belépési linket.');
      return;
    }
    await frissites();
    navigate(biztonsagosVissza(params.get('vissza')), { replace: true });
  }

  return (
    <BelepesKeret cim="Belépés">
      <form onSubmit={linkKeres} className="grid gap-4">
        <Mezo label="E-mail-cím" type="email" name="email" autoComplete="email" required value={email}
          onChange={(e) => setEmail(e.target.value)} suly="Jelszó nincs: e-mailben küldünk egy belépési linket és egy 6 jegyű kódot." />
        <Gomb type="submit" toltes={kuldes}>Belépési link kérése</Gomb>
      </form>
      {elkuldve && (
        <>
          <p role="status" className="rounded-xl border border-kiemelt bg-kiemelt-halvany px-3.5 py-2.5 text-sm">
            Ha van fiókod ezzel a címmel, elküldtük a belépési linket és a kódot.
          </p>
          <form onSubmit={kodBeker} className="grid gap-4">
            <Mezo label="Kód a levélből" name="kod" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}"
              maxLength={6} required value={kod} onChange={(e) => setKod(e.target.value.replace(/\D/g, ''))} />
            <Gomb type="submit" toltes={ellenorzes} disabled={kod.length !== 6}>Belépés</Gomb>
          </form>
        </>
      )}
      {hiba && <p role="alert" className="rounded-xl border border-hiba bg-hiba-hatter px-3.5 py-2.5 text-sm text-hiba">{hiba}</p>}
      {REGISZTRACIO_BE && (
        <p className="border-t border-vonal pt-4 text-sm text-szoveg-halk">
          Új iroda? <Link to="/regisztracio" className="text-kiemelt underline">Regisztráció</Link>
        </p>
      )}
    </BelepesKeret>
  );
}
